import { render, staticRenderFns } from "./ContentNewsRow.vue?vue&type=template&id=1d4a013a"
import script from "./ContentNewsRow.vue?vue&type=script&lang=ts"
export * from "./ContentNewsRow.vue?vue&type=script&lang=ts"
import style0 from "./ContentNewsRow.vue?vue&type=style&index=0&id=1d4a013a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports